<template>
  <div class="content-container">
    <el-form
      :inline="true"
      :model="formInline"
      class="demo-form-inline"
      label-width="100px"
    >
      <div>
        <el-form-item label="洗衣机机器ID">
          <el-input
            v-model="formInline.machineid"
            placeholder="请输入洗衣机机器ID"
            clearable
          ></el-input>
        </el-form-item>

        <el-form-item label="加液器IMEI">
          <el-input
            v-model="formInline.liquidFeederImei"
            placeholder="请输入加液器IMEI"
            clearable
          ></el-input>
        </el-form-item>
      </div>
    </el-form>
    <el-form>
      <el-form-item style="margin-left:1.5rem;">
        <el-button type="primary" icon="el-icon-search" @click="onSubmit"
          >查询</el-button
        >
        <el-button type="primary" icon="el-icon-plus" @click="onAdd"
          >新增</el-button
        >
        <el-button
          type="primary"
          icon="el-icon-delete"
          @click="onBatchDelete"
          :disabled="multipleSelection.length === 0"
          >批量删除</el-button
        >
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      style="width: 100%"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column
        prop="liquidFeederId"
        label="编号"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="machineid"
        label="洗衣机机器ID"
        width="150"
      ></el-table-column>
      <el-table-column
        prop="liquidFeederImei"
        label="加液器IMEI"
        width="150"
      ></el-table-column>

      <el-table-column
        prop="liquidFeederModel"
        label="型号"
        width="150"
      ></el-table-column>

      <el-table-column label="状态" width="150">
        <template slot-scope="scope">
          <el-tag
            type="info"
            effect="dark"
            v-if="scope.row.liquidFeederStatus == -1"
          >
            离线</el-tag
          >

          <el-tag
            type="success"
            effect="dark"
            v-else-if="scope.row.liquidFeederStatus == 0"
            >在线</el-tag
          >
          <el-tag
            type="primary"
            effect="dark"
            v-else-if="scope.row.liquidFeederStatus == 1"
            >运行中</el-tag
          >
          <el-tag
            type="default"
            effect="dark"
            v-else-if="scope.row.liquidFeederStatus == 2"
            >空闲</el-tag
          >
          <el-tag
            type="danger"
            effect="dark"
            v-else-if="scope.row.liquidFeederStatus == 9"
            >异常</el-tag
          >

          <el-tag type="danger" effect="dark" v-else
            >未知{{ scope.row.liquidFeederStatus }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column label="液位" width="260">
        <template slot-scope="scope">
          <div>
            {{ showLiquidVol(scope.row.liquidFeederInfo) }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="状态说明" width="260">
        <template slot-scope="scope">
          <div>
            {{ scope.row.liquidFeederStatusName }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="可用" width="60">
        <template slot-scope="scope">
          <i
            class="el-icon-check"
            style="color:#67c23a;font-weight:bold;"
            v-if="scope.row.liquidFeederEnable"
          ></i>

          <i
            class="el-icon-close"
            style="color:#e66100;font-weight:bold;"
            v-else
          ></i>
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="mini"
            @click="handleDelete(scope.row.id)"
          >
            删除</el-button
          >
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)"
            >详情</el-button
          >
          <div style="padding:3px 0">
            <!--  <el-button
              type="success"
              size="mini"
              @click="handleControl(scope.row, 4)"
              >注册</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="handleControl(scope.row, 3)"
              >排气</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="handleControl(scope.row, 2)"
              >开锁</el-button
            > -->
            <el-button
              type="success"
              size="mini"
              @click="handleControl_ziyan(scope.row)"
              >测试转动</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="handleReset(scope.row)"
              >重启</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="showMoreDialog(scope.row)"
              >更多</el-button
            >
          </div>
          <!-- <div style="padding:3px 0">
            <el-button
              type="success"
              size="mini"
              @click="handleControl(scope.row, 1)"
              >加液</el-button
            >
            <el-button
              type="success"
              size="mini"
              @click="handleControl(scope.row, 9)"
              >复位</el-button
            >
          </div> -->
          <div style="padding:3px 0">
            <!-- <el-button
              type="primary"
              size="mini"
              @click="handleRemoteQuery(scope.row, 11)"
              >状态速查</el-button
            > -->
            <!-- <el-button
              type="primary"
              size="mini"
              @click="handleRemoteQuery(scope.row, 12)"
              >设备信息</el-button
            > -->
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @current-change="handleCurrentChange"
      :current-page.sync="page.currentPage"
      :page-size="page.pageSize"
      layout="total, prev, pager, next"
      :total="page.total"
    ></el-pagination>
    <CreateDialog
      v-if="isCreated"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
    />
    <EditDialog
      v-if="isEdit"
      :liquidFeederInfo="liquidFeederInfo"
      @closeForm="closeForm"
      @handleUpdate="onSubmit"
    />

    <el-dialog
      title="信息"
      :before-close="closeForm"
      :visible="isShowDeviceInfo"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="45%"
    >
      <div v-if="qieDeviceStatus.type == 11">
        <div style="padding: 10px;">
          ⼯作状态: {{ qieDeviceStatus.work_status_text }}
        </div>
        <div style="padding: 10px;">
          ⽹络状态: {{ qieDeviceStatus.net_status_text }}
        </div>
        <div style="padding: 10px;">
          剩余⼯作时⻓（秒）: {{ qieDeviceStatus.remain_second_text }}
        </div>
      </div>
    </el-dialog>

    <el-dialog
      :title="
        '更多操作-' +
          (liquidFeederInfo && liquidFeederInfo.liquidFeederImei
            ? liquidFeederInfo.liquidFeederImei
            : '')
      "
      :before-close="closeForm"
      :visible="isShowMoreDialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="45%"
    >
      <div>
        <div style="padding: 10px;">
          <el-button type="primary" @click="freedom_control_ziyan"
            >设置转动秒数(填写数字)</el-button
          >
          <el-form>
            <el-input
              v-model="feeder_command1"
              placeholder="通道1"
              clearable
              style="width: 120px;margin: 5px;"
            ></el-input
            ><el-input
              v-model="feeder_command2"
              placeholder="通道2"
              clearable
              style="width: 120px;margin: 5px;"
            ></el-input
            ><el-input
              v-model="feeder_command3"
              placeholder="通道3"
              clearable
              style="width: 120px;margin: 5px;"
            ></el-input>
          </el-form>
        </div>

        <div style="padding: 10px;">
          <el-button type="primary" @click="saveMode">设置模式</el-button>
          <el-form>
            <el-radio-group v-model="mMode" style="width: 120px;margin: 5px;">
              <el-radio label="0">0-远程</el-radio>
              <el-radio label="1">1-按键</el-radio>
              <el-radio label="2">2-触发</el-radio>
              <el-radio label="3">3-直通</el-radio>
            </el-radio-group></el-form
          >
        </div>
        <div style="padding: 10px;">
          <el-button type="primary" @click="saveLanguage">设置语言</el-button>
          <el-form>
            <el-radio-group
              v-model="mLanguage"
              style="width: 120px;margin: 5px;"
            >
              <el-radio label="zh">中文</el-radio>
              <el-radio label="en">英语</el-radio>
            </el-radio-group></el-form
          >
        </div>
        <div style="padding: 10px;">
          <el-button type="primary" @click="saveHaosheng"
            >设置屏幕显示毫升数</el-button
          >
          <el-form>
            <el-form-item label="毫升数">
              <el-input
                v-model="haosheng1"
                placeholder="毫升数1"
                clearable
                style="width: 120px;margin: 5px;"
              ></el-input
              ><el-input
                v-model="haosheng2"
                placeholder="毫升数2"
                clearable
                style="width: 120px;margin: 5px;"
              ></el-input
              ><el-input
                v-model="haosheng3"
                placeholder="毫升数3"
                clearable
                style="width: 120px;margin: 5px;"
              ></el-input> </el-form-item
          ></el-form>
        </div>
        <div style="padding: 10px;">
          <el-button type="primary" @click="saveDisplayItem"
            >设置屏幕显示内容</el-button
          >
          0：洗衣液,1：柔顺剂,2：除菌剂
          <el-form>
            <el-form-item label="显示内容">
              <el-input
                v-model="neirong1"
                placeholder="填写代号"
                clearable
                style="width: 120px;margin: 5px;"
              ></el-input
              ><el-input
                v-model="neirong2"
                placeholder="填写代号"
                clearable
                style="width: 120px;margin: 5px;"
              ></el-input
              ><el-input
                v-model="neirong3"
                placeholder="填写代号"
                clearable
                style="width: 120px;margin: 5px;"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import enumObject from "../../plugins/enum";
//import { mapGetters } from "vuex";
import CreateDialog from "@/views/liquid/components/createDialog";
import EditDialog from "@/views/liquid/components/editDialog";

import moment from "moment";

export default {
  components: {
    CreateDialog,
    EditDialog
  },
  data() {
    return {
      formInline: {
        liquidFeederId: "",
        liquidFeederImei: ""
      },
      tableData: [],
      // CITY_ENUM: enumObject.CITY_ENUM,
      // MACHINE_STATUS_ENUM: enumObject.MACHINE_STATUS_ENUM,
      //vendorsList: [],
      // machineEnableList: [
      //   {
      //     label: "全部",
      //     value: ""
      //   },
      //   {
      //     label: "是",
      //     value: true
      //   },
      //   {
      //     label: "否",
      //     value: false
      //   }
      // ],
      multipleSelection: [],
      page: {
        total: 0,
        currentPage: 1,
        pageSize: 10
      },
      isCreated: false,
      isEdit: false,
      // isPrint: false,
      // isControl: false,
      // isShowHandleZhifubaoQRCode: false,
      // zhifubaoQRCodeUrl: null,
      liquidFeederInfo: null,
      // imageIDs: [],
      // shopInfoEntityList: [],
      // vendorEntityList: [],
      // liquidFeederModelList: [],
      //vendorList: [],
      //shopList: [],
      //agentList: []
      // agentListForPrompt: [],
      // vendorListForPrompt: [],
      // shopListForPrompt: []
      isShowDeviceInfo: false,
      isShowMoreDialog: false,
      qieDeviceStatus: {
        type: 0,
        work_status_text: "",
        net_status_text: "",
        remain_second_text: ""
      },
      mMode: undefined,
      mLanguage: "",
      haosheng1: 0,
      haosheng2: 0,
      haosheng3: 0,

      neirong1: 0,
      neirong2: 1,
      neirong3: 2,

      feeder_command1: null,
      feeder_command2: null,
      feeder_command3: null
    };
  },

  async mounted() {
    //console.log(this.$AllMachineModelInfoList);

    this.onSubmit();
  },

  methods: {
    selectHandler(x) {
      console.log("selectHandler", x);
    },
    onSubmit() {
      let queryModel = {
        machineid: this.formInline.machineid,
        liquidFeederImei: this.formInline.liquidFeederImei,
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize
      };

      this.$axios(this.$urlMapping["查询加液器"], {
        data: queryModel
      }).then(result => {
        this.tableData = result.data;
        this.page.total = result.totalCount;
        this.page.currentPage = result.pageNum;
      });
    },
    onAdd() {
      this.isCreated = true;
    },
    onBatchDelete() {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = this.multipleSelection.map(ele => ele.id);
        this.$axios(this.$urlMapping["删除加液器"], {
          data: {
            ids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },

    directToNotifyMessage(liquidFeederId) {
      this.$router.push({
        name: "notifyMessage",
        query: {
          liquidFeederId: liquidFeederId,
          from: this.$ToDateTimeString(moment().subtract(30, "minute")),
          to: this.$ToDateTimeString(moment())
        }
      });
    },
    handleRedirct(liquidFeederId) {
      console.log(liquidFeederId);
      this.$router.push({
        name: "order",
        query: {
          liquidFeederId: liquidFeederId
        }
      });
    },

    handleDelete(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let ids = [id];
        this.$axios(this.$urlMapping["删除加液器"], {
          data: {
            ids
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          this.onSubmit();
        });
      });
    },
    handleEdit(liquidFeederInfo) {
      console.log("handleEdit");
      console.log(liquidFeederInfo);
      this.liquidFeederInfo = liquidFeederInfo;
      this.isEdit = true;
    },

    freedom_control_ziyan() {
      this.$confirm(
        "是否控制机器【" +
          this.liquidFeederInfo.machineid +
          "】绑定的加液器【" +
          this.liquidFeederInfo.liquidFeederImei +
          "】",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        let machineId = this.liquidFeederInfo.machineid;
        // 步骤1：空值/非有效输入直接返回false
        if (
          this.feeder_command1 === "" ||
          this.feeder_command1 === null ||
          this.feeder_command1 === undefined ||
          isNaN(Number(this.feeder_command1))
        ) {
          this.$notify.error({
            title: "错误",
            message: "请输入合法的数字"
          });
          return;
        }
        if (
          this.feeder_command2 === "" ||
          this.feeder_command2 === null ||
          this.feeder_command2 === undefined ||
          isNaN(Number(this.feeder_command2))
        ) {
          this.$notify.error({
            title: "错误",
            message: "请输入合法的数字"
          });
          return;
        }
        if (
          this.feeder_command3 === "" ||
          this.feeder_command3 === null ||
          this.feeder_command3 === undefined ||
          isNaN(Number(this.feeder_command3))
        ) {
          this.$notify.error({
            title: "错误",
            message: "请输入合法的数字"
          });
          return;
        }
        let command1 = this.feeder_command1  + ",1,1,0"; 
        let command2 = this.feeder_command2  + ",1,1,0";
        let command3 = this.feeder_command3  + ",1,1,0";
        console.log(command1);
        console.log(command2);
        console.log(command3);

        this.$axios(this.$urlMapping["测试自研加液器API"], {
          data: {
            machineId,
            command1: command1,
            command2: command2,
            command3: command3
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          // this.onSubmit();
        });
      });
    },

    handleControl_ziyan(liquidFeederInfo) {
      this.$confirm(
        "是否测试机器【" +
          liquidFeederInfo.machineid +
          "】绑定的加液器【" +
          liquidFeederInfo.liquidFeederImei +
          "】",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      ).then(() => {
        let machineId = liquidFeederInfo.machineid;
        this.$axios(this.$urlMapping["测试自研加液器API"], {
          data: {
            machineId,
            command1: "5,1,1,0",  //运行5秒，延迟1秒
            command2: "5,6,1,0",
            command3: "5,8,1,0"
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          // this.onSubmit();
        });
      });
    },
    handleControl(liquidFeederInfo, operationType) {
      let s = "";
      if (operationType == 1) {
        s = "加液";
      } else if (operationType == 2) {
        s = "开锁";
      } else if (operationType == 3) {
        s = "排气";
      } else if (operationType == 4) {
        s = "注册";
      } else if (operationType == 9) {
        s = "复位";
      }
      this.$confirm("是否确认" + s + "?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        let imei = liquidFeederInfo.liquidFeederImei;
        this.$axios(this.$urlMapping["操作加液器"], {
          data: {
            imei,
            operationType
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
          // this.onSubmit();
        });
      });
    },

    handleRemoteQuery(liquidFeederInfo, operationType) {
      let that = this;
      let imei = liquidFeederInfo.liquidFeederImei;
      this.$axios(this.$urlMapping["查询加液器状态"], {
        data: {
          imei,
          operationType
        }
        // eslint-disable-next-line no-unused-vars
      }).then(result => {
        console.log(result);
        if (result.code == 0) {
          if (operationType == 11) {
            that.isShowDeviceInfo = true;
            that.qieDeviceStatus.type = operationType;
            if (result.data.work_status == 10) {
              that.qieDeviceStatus.work_status_text = "空闲";
            } else if (result.data.work_status == 20) {
              that.qieDeviceStatus.work_status_text = "⼯作中";
            } else if (result.data.work_status == 30) {
              that.qieDeviceStatus.work_status_text = "故障";
            }
            if (result.data.net_status == 1) {
              that.qieDeviceStatus.net_status_text = "在线";
            } else if (result.data.net_status == 2) {
              that.qieDeviceStatus.net_status_text = "离线";
            } else if (result.data.net_status == 4) {
              that.qieDeviceStatus.net_status_text = "故障";
            }
            that.qieDeviceStatus.remain_second_text = result.data.remain_second;
          }
        }
        // this.$notifySuccess();
        // this.onSubmit();
      });
    },

    showLiquidVol(jsonStr) {
      let str = "";
      try {
        let jsonObj = JSON.parse(jsonStr);
        // {"resLiquidVol01":"3990","resLiquidVol02":"3990"}
        if (jsonObj.resLiquidVol01) {
          str += "01液位:[" + jsonObj.resLiquidVol01 + "]";
        }
        str += "-";
        if (jsonObj.resLiquidVol02) {
          str += "02液位:[" + jsonObj.resLiquidVol02 + "]";
        }
      } catch (error) {
        str = "error";
      }

      return str;
    },

    showMoreDialog(row) {
      console.log(row);
      this.isShowMoreDialog = true;
      this.liquidFeederInfo = row;
    },

    handleReset(row) {
      console.log(row);

      this.$confirm("是否确认重启?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios(this.$urlMapping["测试自研加液器重启"], {
          data: {
            imei: row.liquidFeederImei
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
        });
      });
    },

    saveMode() {
      console.log(this.mMode);
      if (!this.mMode) {
        this.$message.error("请设置模式！");
        return;
      }

      this.$confirm("是否确认设置模式【" + this.mMode + "】?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios(this.$urlMapping["测试自研加液器设置模式"], {
          data: {
            imei: this.liquidFeederInfo.liquidFeederImei,
            mode: this.mMode
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
        });
      });
    },

    saveLanguage() {
      console.log(this.mLanguage);
      if (!this.mLanguage) {
        this.$message.error("请设置语言！");
        return;
      }
      let lang = "";
      let langCode = 0;
      if (this.mLanguage == "en") {
        lang = "英语";
        langCode = 1;
      } else if (this.mLanguage == "zh") {
        lang = "中文";
        langCode = 0;
      }
      this.$confirm("是否确认设置语言【" + lang + "】?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios(this.$urlMapping["测试自研加液器设置语言"], {
          data: {
            imei: this.liquidFeederInfo.liquidFeederImei,
            language: langCode
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
        });
      });
    },

    saveHaosheng() {
      if (
        this.haosheng1 == "" ||
        this.haosheng2 == "" ||
        this.haosheng2 == ""
      ) {
        this.$message.error("请设置毫升数");
        return;
      }
      this.$confirm("是否确认设置毫升数！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios(this.$urlMapping["测试自研加液器设置通道屏显毫升数"], {
          data: {
            imei: this.liquidFeederInfo.liquidFeederImei,
            values: [this.haosheng1, this.haosheng2, this.haosheng3]
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
        });
      });
    },

    saveDisplayItem() {
      if (
        this.neirong1 === "" ||
        this.neirong2 === "" ||
        this.neirong3 === ""
      ) {
        this.$message.error("设置请屏显内容");
        return;
      }
      this.$confirm("是否确认设置屏显内容", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$axios(this.$urlMapping["测试自研加液器设置通道显示内容"], {
          data: {
            imei: this.liquidFeederInfo.liquidFeederImei,
            values: [this.neirong1, this.neirong2, this.neirong3]
          }
          // eslint-disable-next-line no-unused-vars
        }).then(result => {
          this.$notifySuccess();
        });
      });
    },

    handleCurrentChange(currentPage) {
      this.page.currentPage = currentPage;
      this.onSubmit();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    closeForm() {
      this.isCreated = false;
      this.isEdit = false;
      this.isShowHandleZhifubaoQRCode = false;
      this.isShowDeviceInfo = false;
      this.isShowMoreDialog = false;
    },

    setColor(code) {
      switch (code) {
        case 0:
          return {
            color: "#909399"
          };
        case 2:
          return {
            color: "#409EFF"
          };
        case 8:
          return {
            color: "#E6A23C"
          };
        case 16:
          return {
            color: "#67C23A"
          };
        case 32:
          return {
            color: "#F56C6C"
          };
        default:
          return {
            color: "#000000"
          };
      }
    },
    refreshliquidFeeder(liquidFeederInfo) {
      this.liquidFeederInfo = liquidFeederInfo;
    },
    handleChangeliquidFeederType() {
      this.formInline.liquidFeederModel = "";
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-select {
  width: 202px;
}

/deep/ .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 202px;
}
</style>
